import { render } from "./CardRemind.vue?vue&type=template&id=ec9cd226"
import script from "./CardRemind.vue?vue&type=script&lang=js"
export * from "./CardRemind.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__